var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{staticClass:"icon",class:_vm.chapter.state === 'locked' ? 'locked' : '',attrs:{"src":_vm.iconSource(_vm.chapter),"alt":"..."}})])}
var staticRenderFns = []

export { render, staticRenderFns }